<template>
    <div>
        <main-layout-content :breadcrumbs="pageBreadcrumbs">
            <template v-if="!$auth.isSubdomainActive()" #right-side>
                <common-button
                    type="primary"
                    size="tiny-micro"
                    :label="$t('pages.offer.single_offer.owner')"
                    @click="goToProfile"
                ></common-button>
            </template>

            <template #content>
                <common-tabs ref="tabs" :tabs="tabs" :activeTab="$route.params.type" @tab-change="tabChanged">
                    <template #details>
                        <offer-details
                            v-if="offer"
                            :offer="offer"
                            @check-availability="checkAvailability"
                            @favorites-changed="favoritesChanged"
                        ></offer-details>
                    </template>
                    <template #availability>
                        <check-availability v-if="offer" :offer="offer" :category="category"></check-availability>
                    </template>
                </common-tabs>
            </template>
        </main-layout-content>
    </div>
</template>

<script>
    import MainLayoutContent from 'components/layouts/layout-content/MainLayoutContent'
    import CheckAvailability from 'components/page-elements/availability/CheckAvailability'
    import OfferDetails from 'components/page-elements/offer/OfferDetails'
    import RoutesEnum from 'enums/routes.enum'
    import OfferAPI from 'api/OfferAPI'
    import Store from '~/store'
    import { setSiteTitle, setMetaTitle, setMetaDescription } from '~/helpers'
    import TranslateMixin from 'mixins/TranslateMixin'

    export default {
        mixins: [TranslateMixin],
        components: { CheckAvailability, OfferDetails, MainLayoutContent },

        data: () => ({
            offer: undefined,
            category: undefined,
        }),

        computed: {
            tabs() {
                return [
                    {
                        name: 'details',
                        displayName: this.$t('pages.offer.single_offer.tabs.details'),
                        icon: 'details',
                        withPadding: true,
                    },
                    {
                        name: 'availability',
                        displayName: this.$t('pages.offer.single_offer.tabs.availability'),
                        icon: 'calendar',
                        withPadding: true,
                    },
                ]
            },
            pageBreadcrumbs() {
                return [
                    {
                        label: this.$t('pages.user.user_profile.breadcrumbs.home'),
                        route: { name: RoutesEnum.INDEX.HOME },
                    },
                    {
                        label: this.getTranslation(this.offer?.titleTextContent),
                    },
                ]
            },
        },

        methods: {
            tabChanged(tab) {
                this.$router.push({
                    name: RoutesEnum.OFFER.SINGLE,
                    params: { id: this.$route.params.id, offerType: tab },
                    query: this.$route.query,
                })
            },

            checkAvailability(category) {
                this.category = category
                this.$refs.tabs.tabClicked('availability')
            },

            loadOffer() {
                this.$startLoader()
                const isCalendarFiltered = 1
                return OfferAPI.getOfferById(this.$route.params.id, isCalendarFiltered)
                    .then((offer) => {
                        this.offer = offer
                        setSiteTitle(`${this.offer.titleTextContent.originalText} | Bookeraj`)
                        setMetaTitle(`${this.offer.titleTextContent.originalText} | Bookeraj`)
                        if (this.offer.description) {
                            setMetaDescription(`${this.offer.description}`)
                        }
                        this.$stopLoader()
                    })
                    .catch((error) => {
                        if (error.error.message === 'OFFER.NOT_FOUND') {
                            this.$toast.error(this.$t('common.errors.common_error'))
                            Store.dispatch('configuration/setIsLoading', false)
                            this.$router.push({ name: RoutesEnum.INDEX.HOME })
                        }
                    })
                    .finally(() => {
                        this.$stopLoader()
                    })
            },

            favoritesChanged() {
                this.offer.markedAsFavourite = !this.offer.markedAsFavourite
            },

            goToProfile() {
                if (this.offer?.location?.companyServiceProvider?.id) {
                    this.$router.push({
                        name: RoutesEnum.COMPANY.PROFILE,
                        params: { id: this.offer?.location?.companyServiceProvider.id, companyType: 'profile' },
                    })
                } else {
                    this.$router.push({
                        name: RoutesEnum.USER.PROFILE,
                        params: { id: this.offer?.location?.userServiceProvider?.id, tab: 'profile' },
                    })
                }
            },
        },

        watch: {
            '$route.params.offerType': {
                handler: function () {
                    if (this.$route.params.id && this.$route.params.offerType) {
                        this.$refs.tabs.tabClicked(this.$route.params.offerType)
                    }
                },
            },
        },

        mounted() {
            this.loadOffer()
            this.$nextTick(() => {
                if (this.$route.params.id && this.$route.params.offerType) {
                    this.$refs.tabs.tabClicked(this.$route.params.offerType)
                }
            })
        },
    }
</script>
